"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        button: {
            fontWeight: 'bold',
            fontSize: '12px',
            color: "".concat(themes_1.materialColors.grey[500]),
            padding: 0,
            '& .MuiButton-label': {
                justifyContent: 'flex-start',
            },
        },
        icon: {
            color: '#3E5B73',
        },
    });
});
